export default __webpack_public_path__ + "static/media/nav-per-share.d5525dde.svg";